import { useEffect, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import type { RootState } from '../../redux/store';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Rating from '../../Component/Rating';
import LoadingBox from '../../Component/LoadingBox';
import MessageBox from '../../Component/MessageBox';
import { detailProduct } from '../../redux/actions/productActions';
import Button from '../../Component/Button/index';
import ProductGallery from '../../Component/productoIdComp/ProductPage/ProductGallery.debug.tsx';
import { setMainImageIndex, setLoupeActive } from '../../redux/reducers/productReducer'
import { ProductDescription } from '../../Component/productoIdComp/ProductPage/Description/Description'
import { ProductPrice } from '../../Component/productoIdComp/ProductPage/Price/Price'
import { ResumenCompra } from '../../Component/productoIdComp/ProductPage/Price/ResumenCompra'


import './productoIdScreen.less';
import '../../App.less';




export function useProduct() {
  const dispatch = useDispatch();
  //const product = useSelector(state => state.product.product);
  //const images = useSelector(state => state.product.images);
  const productDetail = useSelector((state: RootState) => state.productDetails) as any;
  const mainImageIndex = useSelector((state: any) => state.product?.mainImageIndex ?? 0);
  const isLoupeActive = useSelector((state: any) => state.product?.isLoupeActive ?? false);

  return {
    //  product,
    // images,
    productDetail,
    mainImageIndex,
    isLoupeActive,
    setMainImageIndex: (index: number) => dispatch(setMainImageIndex(index)),
    setLoupeActive: (active: boolean) => dispatch(setLoupeActive(active)),
  };
}





export default function ProductoIdScreen() {
  interface product {
    imagen: string | string[];
    name: string;
    ArticleNumber: string;
    rating: number;
    numReviews: number;
    price: number;
  }

  const { productDetail, mainImageIndex, isLoupeActive, setMainImageIndex, setLoupeActive } = useProduct()

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [qty, setQty] = useState(1);

  const [priceTax, setPriceTax] = useState(0);

  // const productDetail = useSelector((state: RootState) => state.productDetails) as any;
  const { loading, error, product } = productDetail;


  useEffect(() => {

    dispatch(detailProduct({ id }));
  }, [dispatch, id]);

  const addToCartHandler = () => {
    navigate(`/cart/${id}?qty=${qty}`);
  };

  const resolvedProductId = product?._id || product?.id || id;

  return (
    <div>
      {loading ? (
        <LoadingBox></LoadingBox>
      ) : error ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : !product || Object.keys(product).length === 0 ? (
        <MessageBox variant="danger">Product Not Found</MessageBox>
      ) : (
        <div>
          <Link to="/productos">Back to result</Link>
          <div className='products top'>

            {/* <div className='col-2 '> */}
            <div className='custom-card  col-2'>
              <ProductGallery
                images={product.imagen}
                productId={resolvedProductId}
                mainImageIndex={mainImageIndex}
                setMainImageIndex={setMainImageIndex}
                isLoupeActive={isLoupeActive}
                setLoupeActive={setLoupeActive}
              />
            </div>
            {/* <div>
              <h2>{product.name}</h2>
              <Rating
                rating={product.rating}
                numReviews={product.numReviews}
              ></Rating>

            </div> */}
            {/* <div className='col-1'> */}
            <div className='custom-card col-1'>
              <ProductPrice
                product={product}
                qty={qty}
                setQty={setQty}
                addToCartHandler={addToCartHandler}
              />
            </div>
            <div className='custom-card  col-1'>
              {/* <div className='col-1'> */}
              <ResumenCompra
                product={product}
                qty={qty}
                setQty={setQty}
                addToCartHandler={addToCartHandler}
              />
            </div>


            <div>
              <ProductDescription product={product} />
            </div>

          </div>
        </div>

      )}
    </div>
  );
}
